import React, { Component, forwardRef, Fragment } from 'react';
import { BeatLoader } from 'react-spinners';
import DatePicker from 'react-datepicker';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError, groupBy } from '../../../server/util';
import { get, postResponse, patch, post, put, postWithHeaders, putWithHeadersResponse } from "../../../server/actions";
import { date_format } from "../../../server/constants";
import moment from 'moment';
import Select from 'react-select';
const customManageUsersStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const normalizeSmartPunctuation = (text = '') => {
    if (!text || typeof text !== 'string') return text;

    return text
        // mojibake characters
        .replace(/â€™/g, "'")
        .replace(/â€˜/g, "'")
        .replace(/â€œ/g, '"')
        .replace(/â€/g, '"')
        .replace(/â€“/g, '-')
        .replace(/â€”/g, '--')

        // actual smart punctuation
        .replace(/[‘’]/g, "'")
        .replace(/[“”]/g, '"')
        .replace(/–/g, '-')
        .replace(/—/g, '--');
};

class SupportManagment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showList: true,
            expanded: {},
            adminUsers: [],
            recList: [],
            priorityRecList: [],
            loading: false,
            search: '',
            AllSchools: [],
            existStatus: '',
            disablebtn: false,
            requestObj: {
                issuedesc: '',
                issue: '',
                school: '',
                user: '',
                attachments: [],
                comments: [],
                status: '',
                title: '',
                Comment: '',
                rowID: 0,
                //schoolName:'',
                createdBy: '',
                statusdesc: '',
            },
            newComment: { followUpDate: moment().add('day', 2).toDate(), assigneeId: 0 },
            typeCode: [],
            schoolName: [],
            userName: [],
            statusCode: [],
            selectedOptions: [],
            editList: false,
            isUpdate: false,
            statusValForComment: '',
            schoolId: '',
            loggedUser: JSON.parse(sessionStorage.getItem('loggedInUserDetails'))
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.selectUser = this.selectUser.bind(this);
        this.selectSchool = this.selectSchool.bind(this);
        this.selectType = this.selectType.bind(this);
        this.selectStatus = this.selectStatus.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getStatusData();
        this.getAdminUsers();
        this.getTypeData();
        this.getMealSchoolData();
        this.getAllSchools();
    }
    handleChange = (selectedOptions) => {
        this.setState({
            selectedOptions
        });
        this.filterStatus();
    };
    getAdminUsers = () => {
        get(`/superAdminUsers?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();

        }).then(data => {
            const _adminUsers = data._embedded.superAdminUsers;
            this.setState({ loading: false, adminUsers: _adminUsers });
        }).catch(
            (error) => {
                this.setState({ loading: false, adminUsers: [] });
            }
        )
    }

    getAllSchools = () => {
        this.setState({ loading: true })
        get(`/supportRequests?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();

        }).then(data => {
            let supportData = data._embedded.supportRequests.sort((a, b) => (b.createdOn || '').localeCompare(a.createdOn));
            supportData.map((srItem, i) => {
                supportData[i]["createdOn"] = moment(srItem.createdOn).format('MM/DD/YYYY hh:mm a');
                this.state.typeCode.map((tCode) => {
                    if (tCode.typeCode == srItem.typeCode) {
                        supportData[i]["typeValue"] = tCode.description;
                    }
                });
                this.state.statusCode.map((sCode) => {
                    if (sCode.statusCode == srItem.statusCode) {
                        supportData[i]["statusValue"] = sCode.description;
                    }
                });
            });
            this.setState({ recList: supportData });
            this.setState({
                AllSchools: supportData,
                priorityRecList: supportData.filter(rec => {
                    return rec.statusCode == 8
                }).sort((a, b) => (b.followUpDate || '').localeCompare(a.followUpDate)).map(rec => {
                    const usrRec = this.state.adminUsers.find(usr => {
                        const id = usr._links.self.href.split('/').pop();
                        return id == rec.assigneeId;
                    })
                    rec.assigneeName = usrRec ? `${usrRec.firstName} ${usrRec.lastName}` : '';
                    rec.followUpDate = moment(rec.followUpDate).isValid() ? moment(rec.followUpDate).format('MM/DD/YYYY') : ''
                    return rec;
                })
            }, () => {
                this.filterSchool();
            });
        }).catch(
            (error) => {
                this.setState({ loading: false, AllSchools: [], priorityRecList: [] });
            }
        )
    }
    selectSchool = (e) => {
        const { schoolName } = this.state;
        let idx = e.target.selectedIndex;
        this.state.requestObj.school = e.target.options[idx].value;
        let schoolId = '';
        let userName = [];
        let index = schoolName.findIndex(val => (val.schoolName == this.state.requestObj.school));
        if (index != -1) {
            schoolId = schoolName[index]._links.self.href.split('/').pop();
            userName = schoolName[index].schoolUsers;
        }
        this.setState({ userName: userName });
        this.setState({ "schoolId": schoolId });
        //let dataset = e.target.options[idx].dataset;
    }
    selectUser = (e) => {
        let idx = e.target.selectedIndex;
        this.state.requestObj.user = e.target.options[idx].value;
    }

    selectType = (e) => {
        let idx = e.target.selectedIndex;
        this.state.requestObj.issue = e.target.options[idx].value;
        //let dataset = e.target.options[idx].dataset;
    }
    selectStatus = (e) => {
        const { requestObj, newComment, statusCode } = this.state;
        requestObj.status = e.target.value
        this.setState({ requestObj: { ...requestObj } });
        let index = statusCode.findIndex(val => (val.statusCode == requestObj.status));
        this.setState({ "statusValForComment": "Status changed as " + statusCode[index]['description'] });
    }


    getStatusData = () => {
        this.setState({ loading: true })
        get(`/supportRequest/status?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ statusCode: data });
        }).catch(
            (error) => {
                this.setState({ loading: false });
            }
        )
    }
    getTypeData = () => {
        this.setState({ loading: true })
        get(`/supportRequest/type?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.typeMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ typeCode: data });
        }).catch(
            (error) => {
                this.setState({ loading: false });
            }
        )
    }
    getMealSchoolData = () => {
        this.setState({ loading: true })
        get(`/mealSchools/search/findByIsActive?isActive=true&page=0&size=2147483647&access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response.schoolMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ schoolName: data._embedded.mealSchools });
        }).catch(
            (error) => {
                this.setState({ loading: false });
            }
        )
    }

    handleSave = (e) => {
        e.preventDefault();
        let headers = {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json"
        };
        let user = this.state.loggedUser
        let data = new FormData();
        if (this.state.newComment.attachments && this.state.newComment.attachments.length > 0) {
            data.append('file', this.state.newComment.attachments[0]);
        }
        let formData = {
            "id": this.state.requestObj.rowID,
            //"schoolId":user.schoolId,
            "schoolId": this.state.schoolId,
            "schoolName": this.state.requestObj.school,
            "userName": this.state.requestObj.user,
            "typeCode": this.state.requestObj.issue,
            "statusCode": this.state.requestObj.status,
            "title": normalizeSmartPunctuation(this.state.requestObj.title),
            "description": normalizeSmartPunctuation(this.state.requestObj.issuedesc),
            "comments": normalizeSmartPunctuation((!("description" in this.state.newComment) || this.state.newComment.description == '') ? this.state.statusValForComment : this.state.newComment.description),
            "sendUpdateToCustomer": this.state.isUpdate,
            "assigneeId": this.state.newComment.assigneeId,
            followUpDate: this.state.newComment.followUpDate
        }
        if (this.state.existStatus == this.state.requestObj.status && (this.state.newComment.description == '' || this.state.newComment.description == undefined)) {
            _addNotificationError('Please select status (or) Add Comment.', this);
            return false;
        }
        data.append('body', JSON.stringify(formData));
        this.disable_enableBtn(true);
        putWithHeadersResponse('/supportRequest?access_token=', data, undefined)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                _addNotification('Successfully updated request details.', this);

                const _requestObj = {};
                _requestObj.rowID = 0;
                _requestObj.attachments = [];
                _requestObj.comments = [];
                _requestObj.issue = '';
                _requestObj.issuedesc = '';
                _requestObj.status = '';
                _requestObj.statusdesc = '';
                _requestObj.issuecomment = '';
                _requestObj.title = '';
                _requestObj.createdBy = '';

                this.setState({ issuedesc: '', issue: '', loading: false, newComment: {}, showList: true, isUpdate: false, editList: false, requestObj: { ..._requestObj } });
                this.disable_enableBtn();
                this.getAllSchools();
                this.disable_enableBtn(false);
            }).catch(error => {
                this.setState({ loading: false });
                _addNotificationError('Could not updated request details.', this);
                this.disable_enableBtn(false);
            });
    }
    handleSubmit(e) {
        this.state.requestObj.status = document.getElementById("selectStatus").value;
        const { attachments } = this.state.requestObj;
        e.preventDefault();
        let headers = {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json"
        };
        let user = this.state.loggedUser
        let data = new FormData();
        if (attachments.length > 0) {
            data.append('file', attachments[0]);
        }
        let formData = {
            "schoolId": this.state.schoolId,
            "createdBy": this.state.requestObj.user,
            "schoolName": this.state.requestObj.school,
            "typeCode": this.state.requestObj.issue,
            "statusCode": this.state.requestObj.status,
            "title": normalizeSmartPunctuation(this.state.requestObj.title),
            "description": normalizeSmartPunctuation(this.state.requestObj.issuedesc),
            "comments": normalizeSmartPunctuation(this.state.requestObj.issuecomment),
            "sendUpdateToCustomer": false
        }
        if ((this.state.requestObj.school || '').trim() === '') {
            _addNotificationError('Please select School.', this);
            return false;
        }
        if ((this.state.requestObj.user || '').trim() === '') {
            _addNotificationError('Please select User.', this);
            return false;
        }
        if ((this.state.requestObj.issue || '').trim() === '') {
            _addNotificationError('Please select Issue type.', this);
            return false;
        }
        if ((this.state.requestObj.title || '').trim() === '') {
            _addNotificationError('Please enter Title.', this);
            return false;
        }
        if ((this.state.requestObj.issuedesc || '').trim() === '') {
            _addNotificationError('Please enter Description.', this);
            return false;
        }

        data.append('body', JSON.stringify(formData));
        this.disable_enableBtn(true);
        post('/supportRequest?access_token=', data).then((response) => {
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response;
        }).then(data => {
            _addNotification('Thank you! Our support team will contact you soon.', this);
            this.setState({ issuedesc: '', issue: '', loading: false, newComment: {}, showList: true });
            this.disable_enableBtn();
            this.getAllSchools();
        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError('Please try again!', this);
                this.disable_enableBtn();
            }
        )
        return false;
    }

    getSupportRequestRec = (recId) => {
        this.setState({ loading: true });
        get(`/supportRequests/${recId}?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
        }).then(data => {
            this.getSupportRequestHistory(recId, data);
            this.setState({ loading: false, newComment: { ...this.state.newComment, followUpDate: moment().add('day', 2).toDate() } });
        }).catch(
            (error) => {
                this.setState({ loading: false });
            }
        );
    }

    getSupportRequestHistory = (recId, latestRec) => {
        this.setState({ loading: true });
        get(`/supportRequest/${recId}/history?access_token=`).then((response) => {
            this.setState({ loading: false });
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
        }).then(data => {
            const { requestObj } = this.state;
            if ((data).length > 0) {
                (data.reverse()).map((rec, i) => {
                    requestObj.comments.push({ ...rec });
                });
                latestRec["schoolId"] = data[0].schoolId;
            }
            requestObj.rowID = Number(recId);
            requestObj.issue = latestRec.typeCode;
            requestObj.status = latestRec.statusCode;
            requestObj.title = normalizeSmartPunctuation(latestRec.title || '');
            requestObj.schoolName = latestRec.schoolName;
            requestObj.user = latestRec.user;
            requestObj.issuedesc = normalizeSmartPunctuation(latestRec.description || '');
            requestObj.downloadUri = latestRec.downloadUri;
            requestObj.createdBy = latestRec.createdBy;
            this.setState({ existStatus: latestRec.statusCode });
            this.setState({ requestObj: { ...requestObj }, editList: true, showList: false, schoolId: latestRec.schoolId });


            data._embedded.supportRequests.map((srItem, i) => {
                this.state.typeCode.map((tCode) => {
                    if (tCode.typeCode == srItem.typeCode) {
                        data._embedded.supportRequests[i]["typeValue"] = tCode.description;
                    }
                });

                this.state.statusCode.map((sCode) => {
                    if (sCode.statusCode == srItem.statusCode) {
                        data._embedded.supportRequests[i]["statusValue"] = sCode.description;
                    }
                });
            });
            this.setState({ recList: data._embedded.supportRequests });
        }).catch(
            (error) => {
                this.setState({ loading: false });
            }
        )
    }
    showReqestForm = () => {
        const _requestObj = {};
        _requestObj.rowID = 0;
        _requestObj.attachments = [];
        _requestObj.comments = [];
        _requestObj.issue = '';
        _requestObj.school = '';
        _requestObj.user = '';
        _requestObj.issuedesc = '';
        _requestObj.status = '';
        _requestObj.statusdesc = '';
        _requestObj.issuecomment = '';
        _requestObj.title = '';
        _requestObj.createdBy = '';

        this.setState({ editList: false, showList: false, newComment: {}, requestObj: { ..._requestObj } });
    }
    cancelRequestForm = () => {
        const _requestObj = {};
        _requestObj.rowID = 0;
        _requestObj.attachments = [];
        _requestObj.comments = [];
        _requestObj.editAttachments = [];
        _requestObj.issue = '';
        _requestObj.school = '';
        _requestObj.user = '';
        _requestObj.issuedesc = '';
        _requestObj.status = '';
        _requestObj.statusdesc = '';
        _requestObj.issuecomment = '';
        _requestObj.title = '';
        _requestObj.createdBy = '';
        this.setState({ editList: false, showList: true, newComment: {}, requestObj: { ..._requestObj } });
    }
    editReqestForm = (row) => {
        const recId = row._links.self.href.split("/").pop();
        this.getSupportRequestRec(recId);
    }

    handleCheckBoxChange = (e) => {
        const isUpdate = this.state.isUpdate;
        this.setState({ isUpdate: !isUpdate });
    }

    filterSchool = () => {
        let searchedSchool = [];
        let s = this.state.search;
        if (s.length > 0) {
            this.state.AllSchools.forEach(obj => {
                if (obj.schoolName != null && (obj.schoolName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.title != null && (obj.title.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.description != null && (obj.description.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.comments != null && (obj.comments.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.typeValue != null && (obj.typeValue.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.statusValue != null && (obj.statusValue.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.createdOn != null && (obj.createdOn.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.createdBy != null && (obj.createdBy.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            this.setState({ recList: searchedSchool });
        }

        else {
            this.setState({ recList: this.state.AllSchools });
        }
    };

    filterStatus = () => {
        let filteredS;
        if (this.state.selectedOptions && this.state.selectedOptions.length > 0) {
            filteredS = this.state.AllSchools.filter(itemL => this.state.selectedOptions.some(itemS => itemL.statusCode === itemS.statusCode));
            this.setState({ recList: filteredS });
        }
        else {
            this.setState({ recList: this.state.AllSchools });
        }
    }
    disable_enableBtn = (isDisable = false) => {
        return new Promise((resolve, reject) => {
            this.setState({ disablebtn: isDisable });
            resolve(true);
        });
    }

    renderNewRequestForm = () => {
        const { disablebtn } = this.state;
        const { requestObj, newComment } = this.state;
        const CustomDateInput = forwardRef(
            ({ value, onClick, className, disabled }, ref) => (
                <input value={value} className={className} disabled={disabled} onClick={onClick} ref={ref} />
            ),
        );
        return (
            <div className='row'>
                <div className='col-md-offset-3 col-md-6'>
                    <form>
                        <div className="form-group">
                            {this.state.editList ? <div><label>School Name : </label> &nbsp;&nbsp;<label>{requestObj.schoolName}</label></div> : null} <br />
                            {this.state.editList ? <div><label>Reporter : </label> &nbsp;&nbsp;<label>{requestObj.createdBy}</label></div> : null}

                        </div>
                        {!this.state.editList ?
                            <div>
                                <label htmlFor="school"> School:</label>
                                <select className="form-control" onChange={this.selectSchool}>
                                    <option value="">Select School</option>
                                    {this.state.schoolName &&
                                        this.state.schoolName.map((item, index) => {
                                            return <option value={item.schoolName} disabled={this.state.editList ? true : false}>{item.schoolName}</option>;
                                        })}
                                </select>
                            </div> : null}
                        {!this.state.editList ? <div>
                            <label htmlFor="school"> Reporter:</label>
                            <select className="form-control" onChange={this.selectUser}>
                                <option value="">Select User</option>
                                {this.state.userName &&
                                    this.state.userName.map((item, index) => {
                                        return <option value={item.username} disabled={this.state.editList ? true : false}>{item.username}</option>;
                                    })}
                            </select>
                        </div> : null}
                        <div className="form-group row">
                            <div className='col-md-6'>
                                <label htmlFor="issue">Issue:</label>
                                {this.state.editList ? <select className="form-control" value={this.state.requestObj.issue} disabled={(requestObj.rowID || 0) > 0}>
                                    <option value="">Select Type</option>
                                    {this.state.typeCode &&
                                        this.state.typeCode.map((item, index) => {
                                            return <option value={item.typeCode} disabled={this.state.editList ? true : false}>{item.description}</option>;
                                        })}
                                </select> : <select className="form-control" onChange={this.selectType} disabled={(requestObj.rowID || 0) > 0}>
                                    <option value="">Select Type</option>
                                    {this.state.typeCode &&
                                        this.state.typeCode.map((item, index) => {
                                            return <option value={item.typeCode} disabled={this.state.editList ? true : false}>{item.description}</option>;
                                        })}
                                </select>}

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="status">Status:</label>
                                {this.state.editList ? <select className="form-control" value={this.state.requestObj.status} onChange={this.selectStatus} >
                                    {this.state.statusCode &&
                                        this.state.statusCode.map((item, index) => {
                                            return <option value={item.statusCode} >{item.description}</option>;
                                        })}
                                </select> :
                                    <select id="selectStatus" value={this.state.requestObj.status} className="form-control" onChange={this.selectStatus} disabled style={{ width: '260px' }}>

                                        {this.state.statusCode && this.state.statusCode.map((item, index) => {
                                            return <option value={item.statusCode} disabled={item.description != 'New' ? true : false}>{item.description}</option>
                                            //return (item.description == 'New') ?<option value={item.statusCode}>{item.description}</option>:''
                                        })}
                                    </select>}

                            </div>
                        </div>
                        <div className="form-group">
                            <label>Title: </label>
                            <textarea className="form-control" rows={1} maxLength={300} id="issue-title" value={this.state.requestObj.title} disabled={(requestObj.rowID || 0) > 0} required
                                placeholder="Please provide issue title" spellcheck="false"
                                onChange={(e) => {
                                    this.state.requestObj.title = e.target.value;
                                    this.setState({ requestObj: { ...this.state.requestObj } });
                                }}></textarea>
                        </div>
                        <div className="form-group">
                            <label htmlFor="issuedesc">Description:</label>
                            <textarea className="form-control" rows={5} maxLength={2000} id="issue-desc" value={normalizeSmartPunctuation(this.state.requestObj.issuedesc || '')} disabled={(requestObj.rowID || 0) > 0} required
                                placeholder="Please provide a short description of issue or inquiry" spellcheck="false"
                                onChange={(e) => {
                                    this.state.requestObj.issuedesc = e.target.value;
                                    this.setState({ requestObj: { ...this.state.requestObj } });
                                }}></textarea>
                        </div>
                        <div className='form-group'>
                            <div className='row'>
                                {this.state.requestObj.downloadUri && <div className='col-md-12 text-right'>
                                    <a title="Click to Download File" href={this.state.requestObj.downloadUri}
                                        target='_blank'  ><i className="fa fa-paperclip" aria-hidden="true"></i> Attachment</a>
                                </div>}
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                {
                                    (requestObj.rowID || 0) > 0 ?
                                        <Fragment>
                                            {
                                                requestObj.comments.length > 0 &&
                                                requestObj.comments.map((comm, i) => {
                                                    return <div className="well well-sm"><div className='row'>
                                                        <div className='col-md-12 form-group'>
                                                            <label htmlFor={`issuecomment-${i}`} >Comments:</label>
                                                            <textarea className='form-control' disabled id={`issuecomment-${i}`}
                                                                value={comm.comments}
                                                            ></textarea>
                                                        </div>
                                                        <div className='col-md-6 form-group'>
                                                            <label htmlFor="followUpDate" style={{ paddingRight: '10px' }}>Follow up date:</label>
                                                            <DatePicker id="followUpDate" disabled selected={moment(comm.followUpDate).isValid() ? moment(comm.followUpDate).toDate() : undefined}
                                                                customInput={<CustomDateInput className={'form-control'} disabled />} />
                                                        </div>
                                                        <div className='col-md-6 form-group'>
                                                            <label>Assigned To: </label>
                                                            <select id="assigneeId" value={comm.assigneeId} disabled className="form-control" style={{ width: '260px' }}>
                                                                <option value={0}></option>

                                                                {this.state.adminUsers && this.state.adminUsers.map((item, index) => {
                                                                    const id = item._links.self.href.split('/').pop();
                                                                    return <option value={`${id}`}>{`${item.firstName} ${item.lastName}`}</option>
                                                                })}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-12 from-group'>
                                                            <div className='row'>
                                                                <div className='col-md-12' style={{ fontSize: '10px' }}>
                                                                    <div className='row'>
                                                                        <div className='col-md-8'>
                                                                            <label>Comment By:</label> <label>{comm.modifiedBy}</label>
                                                                        </div>
                                                                        <div className='col-md-4 text-right'><label>On: {moment(comm.modifiedOn, 'YYYY-MM-DDThh:mm:ss').isValid() && moment(comm.modifiedOn, 'YYYY-MM-DDThh:mm:ss').format(`MM-DD-YYYY hh:mm A`)}</label></div>
                                                                    </div>
                                                                </div>
                                                                {comm.downloadUri && <div className='col-md-12 text-right'>
                                                                    <a title="Click to Download File" href={comm.downloadUri}
                                                                        target='_blank'
                                                                    ><i className="fa fa-paperclip" aria-hidden="true"></i> Attachment</a>
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </div></div>
                                                })
                                            }

                                            <div className="form-group">
                                                {this.state.statusCode.filter((status) => {
                                                    return status.statusCode == requestObj.status;
                                                })[0].description != 'Closed' && <Fragment>
                                                        <div>
                                                            <div style={{ display: 'flex' }}>
                                                                <label htmlFor="issuecomment" >Comments:</label>
                                                                <div className="checkbox col-sm-12 text-right" style={{ margin: '0px', padding: '0', right: '0px' }}>
                                                                    <label>
                                                                        <input type="checkbox" name="update" onChange={(e) => { this.handleCheckBoxChange(e) }} />
                                                                        <b>Send an email to the Requested admin</b></label>
                                                                </div>
                                                            </div>
                                                            <textarea className="form-control" rows={3} maxLength={2000} id="comments" value={newComment.description} required
                                                                placeholder="Please provide a short comment of issue or inquiry" spellcheck="false" //style={{width:'510px'}}
                                                                onChange={(e) => {
                                                                    this.state.newComment.description = e.target.value;
                                                                    this.setState({ newComment: { ...this.state.newComment } });
                                                                }}></textarea>
                                                        </div>
                                                        <div className='row' style={{ paddingTop: '10px' }}>
                                                            <div className='col-md-6'>
                                                                <label htmlFor="followUpDate" style={{ paddingRight: '10px' }}>Follow up date:</label>
                                                                <DatePicker id="followUpDate" selected={newComment.followUpDate}
                                                                    onChange={(date) => {
                                                                        this.state.newComment.followUpDate = date;
                                                                        this.setState({ newComment: { ...this.state.newComment } });
                                                                    }}
                                                                    customInput={<CustomDateInput className={'form-control'} />} />
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label>Assigned To: </label>
                                                                <select id="assigneeId" value={newComment.assigneeId} className="form-control" onChange={(e) => {
                                                                    this.state.newComment.assigneeId = e.target.value;
                                                                    this.setState({ newComment: { ...this.state.newComment } });
                                                                }} style={{ width: '260px' }}>
                                                                    <option value={0}></option>
                                                                    {this.state.adminUsers && this.state.adminUsers.map((item, index) => {
                                                                        const id = item._links.self.href.split('/').pop();
                                                                        return <option value={`${id}`}>{`${item.firstName} ${item.lastName}`}</option>
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </Fragment>
                                        : null
                                }
                            </div>
                        </div>
                        <div className='row'>
                            {(this.state.editList) ? this.state.statusCode.filter((status) => {
                                return status.statusCode == requestObj.status;
                            })[0].description != 'Closed' &&
                                <div className='col-md-12 form-group'>
                                    <label htmlFor="attachment">Attachment:</label>
                                    <input type='file' id="attachment" className="form-control"
                                        onChange={(e) => {
                                            if ((e.target.files || []).length <= 0) {
                                                e.target.value = '';
                                                return false;
                                            }
                                            const { requestObj, newComment } = this.state
                                            if (requestObj.rowID > 0) {
                                                newComment.attachments = [e.target.files[0]];
                                                this.setState({ newComment: { ...newComment } });
                                            } else {
                                                requestObj.attachments = [e.target.files[0]];
                                                this.setState({ requestObj: { ...requestObj } });
                                            }
                                            return true;
                                            //} 
                                        }} />
                                </div> : <div className='col-md-12 form-group'>
                                <label htmlFor="attachment">Attachment:</label>
                                <input type='file' id="attachment" className="form-control"
                                    onChange={(e) => {
                                        if ((e.target.files || []).length <= 0) {
                                            e.target.value = '';
                                            return false;
                                        }
                                        const { requestObj, newComment } = this.state
                                        if (requestObj.rowID > 0) {
                                            newComment.attachments = [e.target.files[0]];
                                            this.setState({ newComment: { ...newComment } });
                                        } else {
                                            requestObj.attachments = [e.target.files[0]];
                                            this.setState({ requestObj: { ...requestObj } });
                                        }
                                        return true;
                                    }} />
                            </div>
                            }
                        </div>
                        <div className='row'>
                            <div className='form-group text-right'>
                                <button className="btn btn-danger btn-sm" onClick={() => { this.cancelRequestForm() }}
                                    type="submit" style={{ margin: 0, fontSize: 14 }}>Cancel
                                </button>&nbsp;&nbsp;
                                <button className="btn btn-success btn-sm" onClick={(e) => {
                                    if (requestObj.rowID > 0) {
                                        this.handleSave(e);
                                    } else {
                                        this.handleSubmit(e);
                                    }
                                }}
                                    type="submit" style={{ margin: '0 0 5px 0px', fontSize: 14 }} disabled={disablebtn} >Save
                                </button>

                            </div>
                        </div>
                    </form>

                </div>
            </div>
        )
    }

    getPriorityListColumns = () => {
        const columns = [
            {
                Header: 'Id',
                id: 'id',
                filterMethod: (filter, row) => {
                    const recId = row._original._links.self.href.split("/").pop();
                    return recId == filter.value.toLowerCase();
                },
                Cell: ({ row }) => {
                    const recId = row._original._links.self.href.split("/").pop();
                    return (<Fragment>{recId}</Fragment>)
                },
                width: 50,
            },
            {
                Header: 'Scholl Name',
                accessor: 'schoolName', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.schoolName).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'Title',
                accessor: 'title', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.title).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'Issue Type',
                accessor: 'description',
                style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.description).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Latest Comment',
                accessor: 'comments', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const comments = (row._original.comments) ? row._original.comments : "";
                    return (comments).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Issue',
                accessor: 'typeValue', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.typeValue).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 120,
            },
            {
                Header: 'Status',
                accessor: 'statusValue', style: { textAlign: 'center' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.statusValue).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 100,
            },
            {
                Header: 'Followup date',
                accessor: 'followUpDate',
                style: { textAlign: 'center' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.followUpDate).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 100,
            },
            {
                Header: 'Assigned To',
                accessor: 'assigneeName',
                style: { textAlign: 'center' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.assigneeName).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 100,
            },
            {
                Header: 'Created By',
                accessor: 'createdBy', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.createdBy).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Created Time',
                accessor: 'createdOn', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original;
                    return (_row.createdOn).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'ACTIONS',
                style: { textAlign: 'center' },
                width: 70,
                filterable: false,
                Cell: ({ row }) => (<div>
                    <a title="Edit Request info" onClick={() => this.editReqestForm(row._original)}><i
                        className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon" /></a>
                </div>)
            }
        ];
        return columns
    }


    getColumns = () => {
        const columns = [
            {
                Header: 'Id',
                id: 'id',
                filterMethod: (filter, row) => {
                    const recId = row._original._links.self.href.split("/").pop();
                    return recId == filter.value.toLowerCase();
                },
                Cell: ({ row }) => {
                    const recId = row._original._links.self.href.split("/").pop();
                    return (<Fragment>{recId}</Fragment>)
                },
                width: 50,
            },
            {
                Header: 'Scholl Name',
                accessor: 'schoolName', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.schoolName).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'Title',
                accessor: 'title', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.title).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'Issue Type',
                accessor: 'description',
                style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.description).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Latest Comment',
                accessor: 'comments', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const comments = (row._original.comments) ? row._original.comments : "";
                    return (comments).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Issue',
                accessor: 'typeValue', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.typeValue).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 120,
            },
            {
                Header: 'Status',
                accessor: 'statusValue', style: { textAlign: 'center' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.statusValue).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 100,
            },
            {
                Header: 'Created By',
                accessor: 'createdBy', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.createdBy).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Created Time',
                accessor: 'createdOn', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original;
                    return (_row.createdOn).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'ACTIONS',
                style: { textAlign: 'center' },
                width: 70,
                filterable: false,
                Cell: ({ row }) => (<div>
                    <a title="Edit Request info" onClick={() => this.editReqestForm(row._original)}><i
                        className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon" /></a>
                </div>)
            }
        ];
        return columns;
    }
    renderSummaryPan = () => {
        const { recList, statusCode } = this.state;
        const groupByStatusCode = groupBy(recList, 'statusValue');
        let New = [];
        let InProgress = [];
        let AttentionNeeded = [];
        let Sum = 0;
        if (Object.keys(groupByStatusCode).length > 0) {
            New = groupByStatusCode.hasOwnProperty("New") ? groupByStatusCode["New"] : [];
            InProgress = groupByStatusCode.hasOwnProperty("InProgress") ? groupByStatusCode["InProgress"] : [];
            AttentionNeeded = groupByStatusCode.hasOwnProperty("Attention Needed") ? groupByStatusCode["Attention Needed"] : [];
            let Assigned = groupByStatusCode.hasOwnProperty("Assigned") ? groupByStatusCode["Assigned"] : [];
            let WaitingForDetails = groupByStatusCode.hasOwnProperty("Waiting for details") ? groupByStatusCode["Waiting for details"] : [];
            let Completed = groupByStatusCode.hasOwnProperty("Completed") ? groupByStatusCode["Completed"] : [];
            let WaitingForCustomerReview = groupByStatusCode.hasOwnProperty("Waiting for Customer Review") ? groupByStatusCode["Waiting for Customer Review"] : [];
            Sum = (InProgress.length + WaitingForDetails.length + Assigned.length + Completed.length + WaitingForCustomerReview.length);
        }
        return (
            <div className="row">
                <div className="col-md-4">
                    <div className="input-group">
                        <span className="input-group-addon" >New :</span>
                        <span className="form-control"
                            style={{ background: '#eeeeee', fontWeight: 'bold', textAlign: 'center' }} >{New.length}</span>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="input-group">
                        <span className="input-group-addon" >InProgress:</span>
                        <span className="form-control"
                            style={{ background: '#eeeeee', fontWeight: 'bold', textAlign: 'center' }} >{Sum}</span>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="input-group">
                        <span className="input-group-addon" >Attention Needed:</span>
                        <span className="form-control"
                            style={{ background: AttentionNeeded.length > 0 ? '#f2dede' : '#eeeeee', fontWeight: 'bold', textAlign: 'center' }} >{AttentionNeeded.length}</span>
                    </div>
                </div>
            </div>
        )
    }
    renderSupportList = () => {
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold', textAlign: 'right'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    style: {
                        margin: 'auto !important'
                    },
                    className: "table table-hover"
                }
            },
        };

        const options = this.state.statusCode.map(option => ({
            ...option,
            value: option.statusCode,
            label: option.description
        }));

        return (
            <div className='row'>
                {
                    this.renderPriorityList()
                }
                <div className='col-md-12'>
                    <h5 className='color-1' style={{ fontWeight: 'bolder' }}>All Issues:</h5>
                </div>
                <div className='col-md-3 form-group'>
                    <input type="text" className="form-control" value={this.state.search}
                        name="search" placeholder="Search.." onChange={(e) => {
                            this.setState({ search: e.target.value }, () => {
                                this.filterSchool()
                            })
                        }} autoComplete="off" />
                </div>
                <div className="col-md-3 form-group">
                    <Select
                        options={options}
                        value={this.state.selectedOptions}
                        onChange={(e) => {
                            this.setState({ selectedOptions: e }, () => {
                                this.filterStatus()
                            })
                        }}
                        isMulti
                    // getOptionValue={(option) => option.statusCode.toString()}
                    // getOptionLabel={(option) => option.description}
                    />
                </div>
                <div className="col-md-6">
                    {
                        this.renderSummaryPan()
                    }
                </div>
                <div className='col-md-12'>

                    <ReactTable
                        filterable
                        data={[...this.state.recList.filter(r => r.statusCode != 7), ...this.state.recList.filter(r => r.statusCode == 7)]}
                        //expanded={this.state.expanded}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        noDataText='No data found'
                        sortable={true}
                        defaultSorting={[{
                            id: 'session',
                            desc: false
                        }]}
                        minRows={1}
                    />

                </div>
            </div>
        )
    }
    renderPriorityList = () => {
        return (<Fragment>
            <div className='col-md-12'>
                <h5 className='color-1' style={{ fontWeight: 'bolder' }}>Priority Issues:</h5>
            </div>
            <div className='col-md-12' style={{ marginBottom: '10px' }}>
                <ReactTable
                    filterable
                    data={this.state.priorityRecList}
                    columns={this.getPriorityListColumns()}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    noDataText='No data found'
                    sortable={true}
                    defaultSorting={[{
                        id: 'session',
                        desc: false
                    }]}
                    minRows={1}
                />
            </div>

        </Fragment>

        )
    }
    render() {
        const { showList } = this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                            <h2>
                                <span>Support Management</span>
                            </h2>
                        </div>
                        {showList && <div className="col-md-6 col-sm-12 col-xs-12">
                            <button className="btn btn-success button-sm add-btn-sm"
                                onClick={(e) => this.showReqestForm()}><i className="fa fa-plus" /> New Request</button>
                        </div>}
                    </div>
                    <div className='row'>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            {
                                !showList ?

                                    this.renderNewRequestForm()
                                    :
                                    this.renderSupportList()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SupportManagment;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Schools/supportManagment.jsx